import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { BaseService } from '../../../core/service/base-service';
import { SoCustomerLedgerResponseModel } from '../model/so-customer-ledger-response-model';
import { Observable } from 'rxjs';
import { ResponseData } from '../../../core/modal/base-save-update-response';
import { PartyWiseSalesLedgerModel } from '../model/party-wise-sales-ledger-model';
import { environment } from '../../../../environments/environment';
import { SalesOrderModal } from '../../sales-order/modal/sales-order-modal';
import { SystemConfigModel } from 'src/app/system-config/model/system-config-model';

@Injectable({
  providedIn: 'root',
})
export class PartyWiseSalesLedgerServiceService {
  constructor(public http: HttpClient, public authService: AuthUtilsService) {}
  getSystemConifgData(): Observable<ResponseData<SystemConfigModel>> {
    return this.http.get<ResponseData<SystemConfigModel>>(environment.SERVER_URL + 'sysConfig/getAllByPartner');
  }

  getCustomerLedgerReport(
    reqModel: PartyWiseSalesLedgerModel
  ): Observable<ResponseData<SoCustomerLedgerResponseModel>> {
    return this.http.post<ResponseData<SoCustomerLedgerResponseModel>>(
      environment.SERVER_URL + 'chemical/report/soCustomerLedgerWithPB',
      reqModel
    );
  }

  readyForProduction(salesId: number): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(
      environment.SERVER_URL + 'chemical/salesOrder/readyForProduction/' + salesId
    );
  }

  readyForDispatch(salesId: number): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(
      environment.SERVER_URL + 'chemical/salesOrder/readyForDispatch/' + salesId
    );
  }

  resetForProduction(salesId: number): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(
      environment.SERVER_URL + 'chemical/salesOrder/resetForProduction/' + salesId
    );
  }

  resetForDispatch(salesId: number): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(
      environment.SERVER_URL + 'chemical/salesOrder/resetForDispatch/' + salesId
    );
  }
}
